import { useTranslation } from "react-i18next";

/** Stamp card with as many slots as the owner chose. A full card means one free pass. */
export function StampCard({ stamps, total = 6 }: { stamps: number; total?: number }) {
  const TOTAL = total;
  const { t } = useTranslation();
  const filled = Math.min(stamps, TOTAL);
  return (
    <div role="img" aria-label={t("loyalty.stampsOf", { count: stamps, total: TOTAL })}>
      <div className="flex gap-1.5">
        {Array.from({ length: TOTAL }, (_, i) => (
          <div key={i} className={`flex h-9 w-9 items-center justify-center rounded-full border-2 text-lg ${i < filled ? "border-solar-gold bg-amber-50" : "border-dashed border-gray-300 text-gray-300"}`}>
            {i < filled ? "⭐" : i === TOTAL - 1 ? "🎁" : ""}
          </div>
        ))}
      </div>
    </div>
  );
}
